export const V2_DELIVERABLE_KEYS = ["hook_a", "hook_b", "hook_c", "shared_body"];

const DELIVERABLE_TITLES = {
  hook_a: "Hook A",
  hook_b: "Hook B",
  hook_c: "Hook C",
  shared_body: "Shared body",
};

export function isV2Brief(value) {
  return Number(value?.brief_schema_version) === 2;
}

export function normalizeTextList(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === "string"
          ? item.trim()
          : String(item?.text || item?.label || item?.beat || "").trim()
      )
      .filter(Boolean);
  }
  if (!value) return [];
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      return normalizeTextList(JSON.parse(trimmed));
    } catch {
      return trimmed
        .split(/\r?\n|\s*;\s*/)
        .map((item) => item.replace(/^[-*]\s*/, "").trim())
        .filter(Boolean);
    }
  }
  return [];
}

export function getScriptBrief(data) {
  if (!isV2Brief(data) && !isV2Brief(data?.script)) return null;
  return {
    hook_variants: data?.hook_variants || data?.script?.hook_variants || [],
    shared_body: data?.shared_body || data?.script?.shared_body || {},
    deliverable_label:
      data?.deliverable_label ||
      data?.script?.deliverable_label ||
      "3 hooks + 1 shared body",
  };
}

export function getSubmissionProgress(submission) {
  const counts = isV2Brief(submission)
    ? submission?.performance_counts
    : submission?.clip_counts;
  if (counts) {
    return {
      needed: Number(counts.needed || 0),
      ready: Number(counts.ready || 0),
      needsRetake: Number(counts.needs_retake || 0),
      label: counts.label || "0/0 clips",
    };
  }
  return {
    needed: 0,
    ready: 0,
    needsRetake: 0,
    label: isV2Brief(submission) ? "0/4 deliverables" : "0/0 clips",
  };
}

export function getScriptDeliverableLabel(script) {
  if (isV2Brief(script)) {
    return script.deliverable_label || "3 hooks + 1 shared body";
  }
  const count = Number(script?.shot_count || 0);
  return `${count} ${count === 1 ? "shot" : "shots"}`;
}

export function groupV2Deliverables(submission) {
  const snapshot = submission?.brief_snapshot || {};
  const hooks = new Map(
    (snapshot.hook_variants || []).map((hook) => [hook.deliverable_key, hook])
  );
  const uploaded = new Map(
    (submission?.deliverables || []).map((item) => [item.deliverable_key, item])
  );

  return V2_DELIVERABLE_KEYS.map((key) => ({
    key,
    title: DELIVERABLE_TITLES[key],
    kind: key === "shared_body" ? "body" : "hook",
    brief: key === "shared_body" ? snapshot.shared_body || {} : hooks.get(key) || {},
    upload: uploaded.get(key),
  }));
}
